import React, {useContext, useEffect, useState} from "react";
import "./Overview.css";
import {Link} from "react-router-dom";
import {FormattedMessage, useIntl} from "react-intl";
import {GroupResponse} from "../../../logic/APITypes";
import API, {Resolution} from "../../../logic/API";
import {KeycloakContext} from "../../contextProviders/KeycloakProvider";
import Header from "../../../components/Header";
import {LoadingSkeleton} from "@spg/component_library";
import {JoinedGroup} from "../../../components/GroupTile";
import {GroupLine} from "../../../components/GroupLine";

/** A tile element of the apps list containing overview information of installed applications */
function GroupOverview() {
  const {formatMessage} = useIntl();
  const {isSchAdmin} = useContext(KeycloakContext);

  const [joinedGroups, setJoinedGroups] = useState<Resolution<GroupResponse[]>>(
    {
      unresolved: true,
      success: false,
    },
  );
  const [allGroups, setAllGroups] = useState<Resolution<GroupResponse[]>>({
    unresolved: true,
    success: false,
  });

  useEffect(() => {
    API.getGroups({isMember: true}).then((response) =>
      setJoinedGroups(response),
    );
    if (isSchAdmin)
      API.getGroups({isMember: false}).then((response) =>
        setAllGroups(response),
      );
  }, []);

  return (
    <>
      <Header
        title={formatMessage({id: "groupOverview.header.page"})}
        height={150}
      />
      <div className="content">
        <h2 className="content__header">
          <span className="content__header content__header--no-margin">
            <FormattedMessage id="groupOverview.header.joined" />
          </span>
        </h2>
        <div className="groupOverview__joinedGroups">
          {joinedGroups.unresolved ? (
            <div className="groupOverview__skeleton">
              <LoadingSkeleton />
            </div>
          ) : !joinedGroups.payload ? (
            <p className="groupOverview__noGroups">
              <FormattedMessage id="groupOverview.paragraph.joinedError" />
            </p>
          ) : joinedGroups.payload.length === 0 ? (
            <p className="groupOverview__noGroups">
              <FormattedMessage id="groupOverview.paragraph.joinedEmpty" />
            </p>
          ) : (
            joinedGroups.payload.map((group) => (
              <JoinedGroup key={group.id} {...group} />
            ))
          )}
        </div>
        {isSchAdmin && (
          <>
            <h2 className="content__header groupOverview__header">
              <span className="content__header content__header--no-margin">
                <FormattedMessage id="groupOverview.header.all" />
              </span>
              <Link className="linkButton" to={"/groups/new"}>
                <FormattedMessage id="groupOverview.new" />
              </Link>
            </h2>
            <div className="groupOverview__allGroups">
              {allGroups.unresolved ? (
                <div className="groupOverview__skeleton">
                  <LoadingSkeleton />
                </div>
              ) : !allGroups.payload ? (
                <p className="groupOverview__noGroups">
                  <FormattedMessage id="groupOverview.paragraph.allError" />
                </p>
              ) : allGroups.payload.length === 0 ? (
                <p className="groupOverview__noGroups">
                  <FormattedMessage id="groupOverview.paragraph.allEmpty" />
                </p>
              ) : (
                allGroups.payload.map((group) => (
                  <GroupLine key={group.id} {...group} />
                ))
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default GroupOverview;
